import { EnumProductType } from "gql/generated";

/** Units of each merch variant already in the cart, keyed by variant id. */
export const getCartVariantQuantities = (
  cart: {
    productType: EnumProductType;
    merchVariantId?: string;
    quantity: number;
  }[],
) => {
  const map: Record<string, number> = {};
  for (const item of cart) {
    if (item.productType === EnumProductType.Merch && item.merchVariantId) {
      map[item.merchVariantId] =
        (map[item.merchVariantId] ?? 0) + item.quantity;
    }
  }
  return map;
};
